<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-stepper
          v-model="e1"
          vertical
        >
          <template v-for="chapter in $t('help.chapters')">
            <v-stepper-step
              :key="`${chapter.index}-step`"
              :complete="e1 > chapter.index"
              :step="chapter.index"
              :editable="true"
            >
              {{ chapter.title }}
            </v-stepper-step>
            <v-stepper-content
              :key="`${chapter.index}-content`"
              :step="chapter.index"
            >
              <v-container class="pa-1">
                <v-row>
                  <v-col>
                    <v-card flat>
                      <!-- eslint-disable-next-line vue/no-v-html -->
                      <v-card-text v-html="chapter.content" />
                    </v-card>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-btn
                      v-if="chapter.index > 1"
                      class="mr-2"
                      text
                      @click="prevStep(chapter.index)"
                    >
                      <v-icon>mdi-chevron-left</v-icon>
                      {{ $t("help.previous") }}
                    </v-btn>
                    <v-btn
                      v-if="chapter.index < $t('help.chapters').length"
                      text
                      @click="nextStep(chapter.index)"
                    >
                      {{ $t("help.next") }}
                      <v-icon>mdi-chevron-right</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-stepper-content>
          </template>
        </v-stepper>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      e1: 1,
    };
  },
  created() {
    document.title = this.$t("navbar.help") + " · " + this.$t("appname");
    this.$store.dispatch("setHeader", this.$t("navbar.help"));
  },
  methods: {
    prevStep: function (n) {
      if (n > 1) {
        this.e1 = n - 1;
      }
    },
    nextStep: function (n) {
      if (n < this.$t("help.chapters").length) {
        this.e1 = n + 1;
      }
    },
  },
};
</script>

<style></style>
